/* src/app/components/layout/app-container/app-container.component.scss */
.page-container {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  width: 100%;
}
.page-container .page-header {
  height: 55px;
  z-index: 2;
}
:host-context(.dark-theme) .page-container .page-header {
  background-color: #363636;
}
.page-container .page-header .notifications {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
}
.page-container .page-header .notifications a {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
  text-decoration: none;
}
.page-container .page-body {
  height: 100%;
  overflow: hidden;
}
.page-container .page-footer {
  height: 26px;
  background: #484848;
  width: 100%;
  align-items: center;
  border-top: 1px solid #949494;
  overflow: hidden;
  white-space: nowrap;
}
a.services-agreement {
  color: #FFF;
  text-decoration: none;
  font-size: 10px;
}
a.services-agreement:hover {
  text-decoration: underline;
}
/*# sourceMappingURL=app-container.component.css.map */
